import * as React from 'react'

function HealthServiceIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={47.426} height={56.674} viewBox="0 0 47.426 56.674" {...props}>
      <g data-name="Group 53498">
        <g data-name="Group 53497" stroke="#263238" strokeLinejoin="round">
          <g strokeLinecap="round">
            <path
              data-name="Path 66425"
              d="M0 7.667l37.474-.978 2.213 48.872-37.475.978z"
              fill="#d3dade"
              strokeWidth={0.99961}
              transform="rotate(8 35.16 46.164)"
            />
            <path
              data-name="Path 66426"
              d="M.087 7.503L37.239.428l10.078 47.891-37.152 7.076z"
              fill="#fff"
              strokeWidth={1}
              transform="rotate(8 35.16 46.164)"
            />
            <path
              data-name="Path 66427"
              d="M2.59 6.76a3.317 3.317 0 013.059-2.045h0a3.3 3.3 0 013.3 3.3v6.882a2.205 2.205 0 01-2.2 2.205h0a2.205 2.205 0 01-2.205-2.205V8.361a1.031 1.031 0 011.034-1.032h0a1.031 1.031 0 011.031 1.032v3.512"
              fill="none"
              strokeWidth={1}
              transform="rotate(8 35.16 46.164)"
            />
          </g>
          <g data-name="Group 53496" strokeWidth={1}>
            <path
              data-name="Path 66428"
              d="M7.782.069L7.67 0l-.112.069S2.6 2.725 0 3.733a47.329 47.329 0 001.356 8.242c.892 2.561 4.4 3.938 6.314 4.853 1.918-.915 5.412-2.289 6.314-4.853a46.482 46.482 0 001.359-8.242C12.748 2.725 7.782.069 7.782.069z"
              fill="#d3dade"
              transform="rotate(8 35.16 46.164) rotate(-13 90.304 -51.359)"
            />
            <path
              data-name="Path 66429"
              d="M5.455 7.854l2.47 1.594 2.47-3.485"
              fill="none"
              strokeLinecap="round"
              transform="rotate(8 35.16 46.164) rotate(-13 90.304 -51.359)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default HealthServiceIcon
